import React, { useMemo } from 'react';

// Renders a ported handoff scene builder behind the centred BARE badge. Each
// builder (from handoffScenes.js) returns a complete inline-SVG string that
// draws its own full-bleed sky + scene; we inject it verbatim so the handoff
// art is preserved byte-for-byte. The SVG is our own static markup (no user
// input), so dangerouslySetInnerHTML is safe here. useMemo keeps the builder's
// random traits stable for the life of the mount (re-mount to re-roll).
export default function HolidayScene({ builder })
{
    const html = useMemo(() => builder(), [builder]);
    return <span className="hol-stage" dangerouslySetInnerHTML={{ __html: html }} />;
}
